import React from "react";
import { useSiteSettings } from "@/context/SiteSettingsContext";
import { Sparkles } from "lucide-react";

export default function PromoBanner() {
  const { settings } = useSiteSettings();
  const text = (settings.promo_banner_text || "").trim();
  if (!text) return null;
  return (
    <div data-testid="promo-banner" className="w-full bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-500 text-black">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-2 flex items-center justify-center gap-2 text-center">
        <Sparkles className="h-4 w-4 shrink-0"/>
        <p className="font-display font-medium text-sm sm:text-base tracking-tight">{text}</p>
        <Sparkles className="h-4 w-4 shrink-0"/>
      </div>
    </div>
  );
}
